import React from "react";
import "../Styles/Home.css";
import Counter from "./Counter";

const Presence = () => {
  return (
<>

    <div className="career-image" id="join">
        <img src="./corporate/presence.png" alt="" />
    </div>
    <section className="section-presence">
      <h1>Our Presence</h1>

      <p className="presence">
        Swastika Infra Ltd is committed to shaping a sustainable and progressive
        future with a global vision. We continuously innovate, embrace
        cutting-edge technology and uphold the highest standards of quality
        and sustainability.
      </p>

     <section className="section-presence" id="section-presences">

  <div className="stats-section">  

    <div className="stats-image">
      <img src="/images/MAP2.png" alt="Map" />
    </div>

    <div className="stats-column">
      <Counter value={15} label="Years of Experience" />
      <Counter value={1500} label="Orders Book" suffix="Cr.+" /> 
      <Counter value={200} label="Staff" />
      <Counter value={40} label="Projects Completed" />
      <Counter value={2000} label="Villages Electrified" />
    </div>

  </div>

  
</section>

      <p className="presence">
       Engineering Excellence across Roads, Power and Renewables
      </p>
    </section>
</>
  );
};

export default Presence;


